// src/service/Dashboard.js
import instance from '../apis/app';

const Dashboard = {
  getKpis: async () => {
    try {
      const response = await instance.get('/admin/dashboard/kpis');
      return response.data?.data ?? response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
};

export default Dashboard;
